import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Modality } from '../../interfaces/api/modality';
import { fetchModalities } from '../services/modalities.service';

interface ModalityState {
	modalities: {
		[id: number]: Modality;
	};
	peopleCountModality: Modality | undefined;
	soundLevelModality: Modality | undefined;
	isLoading: boolean;
}

const initialState = {
	modalities: [],
	peopleCountModality: undefined,
	soundLevelModality: undefined,
	isLoading: false,
} as ModalityState;

export const fetchModalitiesThunk = createAsyncThunk<Modality[], void>(
	'modality/fetchModalities',
	async (_undefined, { rejectWithValue }) => {
		try {
			return await fetchModalities();
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

const modalitySlice = createSlice({
	name: 'modality',
	initialState,
	reducers: {
		resetModality: (state) => {
			Object.assign(state, initialState);
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchModalitiesThunk.fulfilled, (state, action) => {
			state.peopleCountModality = action.payload.find(
				(modality) => modality.modalityType === 'People counter'
			);
			state.soundLevelModality = action.payload.find(
				(modality) => modality.modalityType === 'Sound level'
			);
			const ret: { [id: number]: Modality } = {};
			state.modalities = action.payload.reduce((obj, modality) => {
				obj[modality.id] = modality;
				return obj;
			}, ret);
			state.isLoading = false;
		});
		builder.addCase(fetchModalitiesThunk.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchModalitiesThunk.rejected, (state, action) => {
			state.modalities = [];
			state.isLoading = false;
		});
	},
});

export const { resetModality } = modalitySlice.actions;

export default modalitySlice;
